import script from "./Choose.vue?vue&type=script&setup=true&lang=js"
export * from "./Choose.vue?vue&type=script&setup=true&lang=js"

import "./Choose.vue?vue&type=style&index=0&id=27a4f3ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a4f3ce"]])

export default __exports__